<template>
  <div class="page page-film">
    <div class="container film-wrap" v-if="film">
      <div class="film-main">
        <div class="film-title">
          <div class="left">
            <div class="name">正在為你播放《{{film.film_title}}》</div>
            <div class="tips">本網站電影只作學術研究及分享用途，會員下載觀賞後，請馬上刪除，尊重知識產權</div>
          </div>
          <div class="right">
            <el-button icon="el-icon-edit" plain @click="openDialog">寫影評</el-button>
            <div class="comments">
              已有<a>&nbsp;{{commentCount}}&nbsp;</a>條影評
            </div>
          </div>
        </div>

        <div class="player">
          <div class="mask" v-if="!start">
            <i class="el-icon-video-play" @click="play"></i>
          </div>
          <video controls preload ref="video" @error="loadErr"
            :src="film.film_url.indexOf('http') == 0 ? film.film_url : `${$config.urlBase}${film.film_url.substr(film.film_url.indexOf('/'))}`">
          </video>
        </div>
      </div>

      <div class="film-aside">
        <img :src="$getImg(film.cover)" alt="" class="cover">
        <div class="en-title">{{film.film_english_title}}</div>
        <div class="cn-title">{{film.film_title}}</div>
        <div class="detail">{{film.film_detail}}</div>
      </div>  
    </div>

    <el-dialog title="發表評論" :visible.sync="dialogShow" :close-on-click-modal="false" :show-close="false" width="640px">
      <el-form :model="form" label-width="120px" :rules="rules" ref="form">
        <el-form-item label="姓名" prop="user">
          <el-input v-model.trim="form.user" maxlength="20"
            autocomplete="off" placeholder="請輸入姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="分享感想" prop="content">
          <el-input v-model="form.content" autocomplete="off"  placeholder="請輸入感想"
            type="textarea" :autosize="{ minRows: 4, maxRows: 10}">            
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submit" native-type="submit" :loading="submitting">發 表</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '../services/api'
import helpers from '../utils/helpers'

export default {
  data() {
    return {
      film: null,
      commentCount: 0,
      start: false,
      dialogShow: false,
      submitting: false,
      form: {
        user: '',
        content: ''
      },
      rules: {
        user: [
          { required: true, message: '請輸入姓名', trigger: 'change' }
        ],
        content: [
          { required: true, message: '請輸入內容', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    getFilm() {
      api.getFilm({ id: this.filmId }).then(data => {
        this.film = data
        helpers.setTitle(data.film_title)
      })
    },
    getComments() {
      api.getComments({ film: this.filmId }).then(data => {
        this.commentCount = data.qty
      })      
    },
    play() {
      this.$refs.video.play()
      this.start = true
    },
    loadErr() {
      this.$message.error('視頻載入失敗')
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitting = true

          api.postComment({
            ...this.form,
            film: this.filmId
          }).then(() => {
            this.$message.success('發表成功')
          }).finally(() => {
            this.submitting = false
            this.dialogShow = false
          })
        }
      })
    },
    openDialog() {
      this.dialogShow = true
      this.$refs.form && this.$refs.form.resetFields()
    },
    closeDialog() {
      if (this.submitting) {
        return;
      }
      this.dialogShow = false
    }
  },
  created() {
    this.filmId = this.$route.params.id
    this.getFilm()
    this.getComments()
  }
}
</script>

<style lang="less" scoped>
.page-film {
  background-color: rgb(25,25,25);
  padding: 55px 0;
  color: white;
}

.film-wrap {
  display: flex;
}

.film-main {
  margin-right: 54px;
  flex: 1;
}

.film-title {
  display: flex;

  .left {
    flex: 1;
    line-height: 1.5;
  }

  .name {
    font-size: 24px;
  }

  .tips {
    font-size: 14px;
    margin-top: 11px;
    color: rgb(169,161,157);
  }

  .right {
    text-align: center;
    margin-left: 20px;
    padding-top: 2px;

    .el-button {
      width: 120px;
      border-radius: 8px;
    }    
  }

  .comments {
    margin-top: 6px;
    font-size: 13px;

    a {
      color: white;
      text-decoration: underline;
    }
  }
}

.player {
  position: relative;
  margin-top: 50px;

  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    background-color: rgba(0,0,0,.7);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 64px;
      cursor: pointer;
    }
  }

  video {
    height: 574px;
    background-color: black;
    max-width: 100%;
    outline: 0;
  }
}

.film-aside {
  width: 360px;
  line-height: 1.5;

  .cover {
    width: 100%;
    display: block;
  }

  .en-title {
    font-size: 14px;
    font-weight: 600;
    margin-top: 17px;    
  }

  .cn-title {
    font-size: 20px;
    margin-top: -3px; 
  }

  .detail {
    font-size: 13px;
    margin-top: 15px;
  }
}

</style>
